import { all, takeEvery } from 'redux-saga/effects';
import { ACTIONS } from '../types';
import { changeCommissionModeSaga } from './changeCommissionModeSaga';

export function* commissionModeRootSaga() {
  yield all([takeEvery(ACTIONS.CHANGE_COMMISSION_MODE, changeCommissionModeSaga)]);
}
